import { apiRTK, Tag } from 'api/api-rtk'

import type * as API from './types'

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		complete: create.mutation<any, string>({
			invalidatesTags: [Tag.Executions],
			query: id => ({
				method: 'PUT',
				url: `executions/${id}/complete`
			})
		}),

		page: create.query<API.PageResponse, Partial<API.PageParams>>({
			providesTags: [Tag.Executions],
			query: params => ({
				method: 'GET',
				params,
				url: 'executions/page'
			})
		}),

		resume: create.mutation<any, string>({
			invalidatesTags: [Tag.Executions],
			query: id => ({
				method: 'PUT',
				url: `executions/${id}/resume`
			})
		})
	})
})
